/* eslint-disable jsx-a11y/anchor-is-valid */
import React ,{useEffect,useState} from "react";
import { Tab , Nav } from "react-bootstrap";
import axios from "axios";
import { NODE_API_URL,BASE_URL } from "../../../env_config";
import Cookies from "js-cookie"
import { useHistory, useLocation } from "react-router-dom";
import { ApiSettings } from "../settings/ApiSettings/ApiSettings";
import { ApiCurrencyAndTax } from "../settings/ApiSettings/ApiCurrencyAndTax";
import { ApiLogs } from "../settings/ApiSettings/ApiLogs";
import { FeedApprovedFrame } from "../DiamondFeedNew";
import { SupplierManagement } from "../DiamondFeedNew/SupplierManagement";
export const ApiSetting = (props) => {
    const history = useHistory();
    const [key, setKey] = useState('apisetting');
    const location = useLocation()
    const [feedsetting,setFeedSetting] = useState(null)
    useEffect(() => {
        axios({
            method: "get",
            url: `${NODE_API_URL}/INTL/fetch-iframeorapi`,
            headers: {
                "Content-Type": "application/json",
                 "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            }
        }).then(supreq => {
            if(supreq && supreq.data && supreq.data.data){
                // setFeedLoader(false)
                setFeedSetting(supreq.data.data)
            }
        }).
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
    },[])
    // console.log(customeriframe,"customeriframesetting")
    return (
        <>
        {feedsetting && feedsetting.api === 1 && feedsetting.feed_type === "API"?<div className="container-fluid">
            <Tab.Container id="settingTab" activeKey={key} onSelect={(k) => setKey(k)}>
            <div className="row">
                    <div className="col-md-3">
                        <div className="card custom-card gutter-b border-0 rounded-0">
                            <div className="card-body p-3">
                                <Nav
                                    variant="pills"
                                    className="flex-column custom_nav"
                                >
                                    <Nav.Item >
                                        <Nav.Link className="flex-wrap"
                                        onClick={() => history.push({
                                            pathname: "/diamondfeed"
                                        })}
                                        >
                                           <span className="font-size-h5 px-0 col-12">API Dashboard</span >
                                           <span className="text-muted small px-0 col-12">Back to rule page</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item >
                                        <Nav.Link className="flex-wrap" eventKey="apisetting">
                                           <span className="font-size-h5 px-0 col-12">{props.language.SETTING_API_SETTING}</span >
                                           <span className="text-muted small px-0 col-12">{props.language.SETTING_API_SETTINGS}</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    {feedsetting.api_plan !== "API_V2"?<Nav.Item >
                                        <Nav.Link className="flex-wrap" eventKey="apicurrency">
                                           <span className="font-size-h5 px-0 col-12">API Currency & Tax</span >
                                           <span className="text-muted small px-0 col-12">API Currency & Tax Setting</span>
                                        </Nav.Link>
                                    </Nav.Item>:""}
                                    {/* <Nav.Item>
                                        <Nav.Link className="flex-wrap" eventKey="apilogs">
                                           <span className="font-size-h5 px-0 col-12">API Logs</span >
                                           <span className="text-muted small px-0 col-12">API Logs Data</span>
                                        </Nav.Link>
                                    </Nav.Item> */}
                                    <Nav.Item>
                                        <Nav.Link className="flex-wrap" eventKey="suppliermanagement">
                                           <span className="font-size-h5 px-0 col-12">Supplier Management</span >
                                           <span className="text-muted small px-0 col-12">Manage Suppliers</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 bg-white rounded p-8"style={{boxShadow:"rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px"}}>
                        <div className="card custom-card rounded-0">
                            <div className="card-body">
                                <Tab.Content>
                                    <Tab.Pane eventKey="apisetting">
                                        <ApiSettings userinfo={props.userinfo} language={props.language} feedsetting={feedsetting}/>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="apicurrency">
                                        <ApiCurrencyAndTax userinfo={props.userinfo} language={props.language} feedsetting={feedsetting}/>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="apilogs">
                                        <ApiLogs userinfo={props.userinfo} language={props.language} feedsetting={feedsetting}/>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="suppliermanagement">
                                        <SupplierManagement language={props.language} conversionrate={props.conversionrate} symbol={props.symbol} userinfo={props.userinfo}  feedsetting={feedsetting}/>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </div>
                </div>
            </Tab.Container>
        </div>:""}
        </>
    );
};
